//----------------------
// auto troop roll-offs
//----------------------
// only where matching rank/dex does not include non-troops
export default function autoTroopRollOffs(dupes) {
  console.log("-------------------");
  console.log("IN autoTroopRollOffs cnt = " + dupes.length);
  let still_dupes = [];
  let troop_roll_offs = [];
  var i = 0;
  var j = 0;
  //-----------------
  // loop thru dupes
  //-----------------
  while (dupes.length > 1) {
    // grab dupe combatant
    let d = dupes[i];
    //
    // console.log(
    //   "autoTroopRollOffs dupe = " +
    //     d.name +
    //     " type = " +
    //     d.type +
    //     " rank = " +
    //     d.rank +
    //     " dex = " +
    //     d.dex +
    //     " dupe = " +
    //     d.dupe_rank +
    //     " dupe_processed = " +
    //     d.dupe_processed
    // );
    //-----------------------
    // get matching rank/dex
    //-----------------------
    let same_rank_dex = dupes.filter((c) => c.rank == d.rank && c.dex == d.dex);
    //-------------------------------------
    // get same rank + dex + type <> troop
    //-------------------------------------
    let non_troops = dupes.some(
      (c) => c.rank == d.rank && c.dex == d.dex && c.type != "Troop"
    );
    // console.log("non_troops = " + non_troops);
    //------------------------------------
    // where non-troops mixed with troops
    //------------------------------------
    if (non_troops) {
      //--------------------------------------------------------------
      // mix - cannot auto roll-off for rank/dex combos - still dupes
      //--------------------------------------------------------------
      // console.log("push still dupes cnt = " + same_rank_dex.length);
      same_rank_dex.forEach((s) => {
        still_dupes.push(s);
      });
    } else {
      //----------------------------------------------------------------
      // no mix - assign roll-off + clear dupe flag for rank/dex combos
      //----------------------------------------------------------------
      // console.log("push troop roll-off cnt = " + same_rank_dex.length);
      same_rank_dex.forEach((s) => {
        j = j + 1;
        s.roll_off = j;
        s.dupe_rank = false;
        s.dupe_processed = true
        troop_roll_offs.push(s);
      });
    }
    //-------------------
    // increment dupe el
    //-------------------
    i++;
    //------------------------------
    // remove pushed els from dupes
    //------------------------------
    dupes = dupes.filter((r) => !same_rank_dex.includes(r));
    // console.log("DUPES CNT NOW = " + dupes.length);
  }
  //----------------
  // return results
  //----------------
  return [still_dupes, troop_roll_offs];
}
